import React, { useState, useEffect, useMemo } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import MarkactiveConfirmationModal from "../../../components/Modal/MarkActive";
import { checkUserPermission } from "../../../common/UserPermission";
import axios from "axios";
import moment from "moment";
//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { toastSuccess } from '../../../../common/Toast';
// import { DELETE_MESSAGE } from '../../../../common/Constant';
// import { checkUserPermission } from '../../../common/UserPermission';

export const ManageInactiveAccount = () => {
  let selectData = [];
  const loginuserid = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");

  const [loading, setLoading] = useState(false);
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [data, setData] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const navigate = useNavigate();

  const columns = useMemo(() => [
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Chart Of Account Type",
      accessorKey: "ChartOfAccountType",
      size: 140,
    },
    {
      header: "Account Type",
      accessorKey: "AccountType",
      size: 130,
    },
    {
      header: "Account Detail Type",
      accessorKey: "AccountDetailType",
      size: 130,
    },
    {
      header: "Balance",
      accessorKey: "Amount",
      size: 120,
    },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      Cell: ({ row }) => {
        return moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A");
      },
    },
  ]);

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  const handleRowSelected = (e) => {
    // console.log(e,"event")
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.Id));
      selectData[currentPage] = e.selectedRows.map((x) => x.Id);
      console.log(selectData, "selectData");
      const selectedDataDeleteData =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      // console.log(selectedDataDeleteData,"selectedDataDelete")
      setSelectedDataDelete(selectedDataDeleteData);
    }
  };

  const handleDeletePopup = (id) => {
    console.log(id, "id");

    // const deleteRequestParam = {
    //   accountids: pID || dd,
    // };
    // const deleteRequestParam = {
    //   accountids: selectedDataDelete,
    // };
    // console.log(deleteRequestParam,"deleteRequestparams" )
    localStorage.setItem("DeleteRequestParam", id);
    setDeleteModalOpen(true);
  };

  const contextActions = useMemo(() => {
    return (
      checkUserPermission("mark-active") && (
        <div className="row px-2">
          <button
            type="button"
            className="btn btn-danger btn-sm pull-left "
            data-bs-toggle="modal"
            data-bs-target="#MarkactiveConfirmationModal"
            onClick={handleDeletePopup}
          >
            <i className="fa fa-trash fa-sm" /> Mark Active
          </button>
        </div>
      )
    );
  }, [data, selectedRows, toggleCleared]);

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingDate,
    endingDate,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/accountselectallinactive?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&startdate=${startingDate}&enddate=${endingDate}&createdby=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate
    );
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPageSize,
      e.target.value,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
    console.log(handleListData);
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [columnFilters, globalFilter, pagination, sorting]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h6 className="page-title">InActive Accounts</h6> */}
              <ul className="breadcrumb" style={{ marginLeft: "11px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/accounting">Accounting</Link>
                </li>
                <li className="breadcrumb-item active">
                  InActive Accounts List
                </li>
              </ul>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4"></div>
            <div>
              <div className="btn-group pull-right ms-2 ">
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    style={{ borderRadius: "5px", padding: "8px" }}
                    onClick={() => navigate("/accounting")}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row flex-row-reverse">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div>
          </div> */}

          {/* Customer list */}
          {/* <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title=" InActive Accounts List"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div> */}

          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            enableRowActions={
              checkUserPermission("mark-active") ||
              checkUserPermission("/view-register/:id")
            }
            positionGlobalFilter="left"
            renderRowActionMenuItems={({ row }) => [
              checkUserPermission("/view-register/:id") ? (
                <MenuItem
                  key="edit"
                  onClick={() => navigate(`/view-register/${row.original.Id}`)}
                >
                  View Register
                </MenuItem>
              ) : null,
              checkUserPermission("mark-active") ? (
                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"
                  title="Delete"
                  data-bs-toggle="modal"
                  data-bs-target="#DeleteConfirmationModal"
                  onClick={() => handleDeletePopup(row.original.Id)}
                >
                  Mark Active
                </MenuItem>
              ) : null,
            ]}
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "comfortable",
              showGlobalFilter: true,
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            //For color of each alternative row(Zebra-column)
            muiTableBodyProps={{
              sx: () => ({
                "& tr:nth-of-type(even)": {
                  backgroundColor: "var(--datatable-row-background-color)",
                  //'rgb(237 237 233 / 63%)'
                },
                "& td": {
                  borderRight:
                    "1px solid var(--datatable-row-background-hover-color)",
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },

                "& tr": {
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },
              }),
            }}
            muiPaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              // isError
              // ? {
              //   color: "error",
              //   children: "Error loading data",
              // }
              // : undefined
              {
                isError: () => ({
                  color: "error",
                  children: "Error loading data",
                }),
                sx: (theme) => ({
                  background: "var(--datatable-row-background-color)", //'#e9e9e9',
                  lineHeight: "16px",
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                }),
              }
            }
            muiTableHeadCellProps={{
              sx: (theme) => ({
                background: "var(--datatable-row-background-color)", //'#e9e9e9',
                borderRight:
                  "1px solid var(--datatable-row-background-hover-color)",
                lineHeight: "16px",
                fontWeight: "500",
                fontSize: "14px",
                color: "var(--primary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            // muiSelectCheckboxProps={{ sx: theme => ({
            //   lineHeight: '16px',
            //   fontWeight: '400',
            //   fontSize:'12px',
            //   color:'var(--prinary-color-800)',
            //   fontFamily:'Inter'
            //   })
            // }}
            // muiSelectAllCheckboxProps={{ sx: theme => ({

            //   lineHeight: '16px',
            //   fontWeight: '400',
            //   fontSize:'12px',
            //   color:'var(--prinary-color-800)',
            //   fontFamily:'Inter'
            //   })
            // }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              columnFilters,
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            // renderTopToolbarCustomActions={({ table }) => (
            //   <Box
            //     sx={{
            //       display: "flex",
            //       gap: "1rem",
            //       p: "0.5rem",
            //       flexWrap: "wrap",
            //     }}
            //   >
            //     <Button size="small"
            //       color="primary"
            //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            //       onClick={handleexcelexport}
            //       startIcon={<FileDownloadIcon />}
            //       variant="contained"
            //     >
            //       Export All In Excel
            //     </Button>
            //     <Button size="small"
            //       disabled={
            //         !table.getIsSomeRowsSelected() &&
            //         !table.getIsAllRowsSelected()
            //       }
            //       //only export selected rows
            //       onClick={() =>
            //         handleExportRows(table.getSelectedRowModel().rows)
            //       }
            //       startIcon={<FileDownloadIcon />}
            //       variant="contained"
            //     >
            //       Export Selected Rows in Excel
            //     </Button>
            //     <Button size="small"
            //       color="primary"
            //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            //       onClick={() => downloadPDF("", "allData")}
            //       startIcon={<FileDownloadIcon />}
            //       variant="contained"
            //     >
            //       Export All In Pdf
            //     </Button>
            //     <Button size="small"
            //       disabled={
            //         !table.getIsSomeRowsSelected() &&
            //         !table.getIsAllRowsSelected()
            //       }
            //       //only export selected rows
            //       onClick={() =>
            //         downloadPDF(table.getSelectedRowModel().rows, "selectedRow")
            //       }
            //       startIcon={<FileDownloadIcon />}
            //       variant="contained"
            //     >
            //       Export Selected Rows in Pdf
            //     </Button>
            //     <Button
            //       color="primary"
            //       variant="contained"
            //       onClick={() => buttonPrint()}>
            //       Print PDF
            //     </Button>
            //   </Box>
            // )}
            // renderTopToolbarCustomActions={({ table }) => (
            //   <Box
            //     sx={{
            //       display: "flex",
            //       gap: "1rem",
            //       p: "0.5rem",
            //       flexWrap: "wrap",
            //     }}
            //   >
            //     <Button
            //       size="small"
            //       onClick={() =>
            //         setPagination({ ...pagination, pageSize: totalRows })
            //       }
            //       variant="contained"
            //     >
            //       Get All Data
            //     </Button>
            //   </Box>
            // )}
          />
        </div>
      </div>
      <MarkactiveConfirmationModal
        InactiveApiUrl={`${config.accountingBaseUrl}/chartofaccounts/accountinactive`}
        rows={selectedRows.length}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};
